// Import Stimulus controllers
import { Application } from "@hotwired/stimulus"

// Import custom controllers
import AttachmentController from "./attachment_controller.js"
import CrmCaseAlertsController from "./crm_case_alerts_controller.js"
import ReturnGrnController from "./return_grn_controller.js"
import ReturnsSearchController from "./returns_search_controller.js"

// Initialize Stimulus application
const application = Application.start()

// Register controllers
application.register("attachment", AttachmentController)
application.register("crm-case-alerts", CrmCaseAlertsController)
application.register("return-grn", ReturnGrnController)
application.register("returns-search", ReturnsSearchController)

// Configure Stimulus
application.debug = false
application.stimulusDebug = false

export { application }
